export const BannerColumns = (() => {
	'use strict';

	function init() {
		// if ($("#pxMainContent :first-child").hasClass('')) {
		// 	$('body').addClass('text-color--light');
		// 	$('body').addClass('banner--column');
		// } else {}
	}

	return {
		init: init,
		name: 'banner-columns'
	};
})();
